module.exports = __webpack_public_path__ + "static/media/p-content-1.ad539647.png";